import "./Industries.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ModernHealthcareSimplified from "./sections/ModernHealthcareSimplified";
import SectorSpecificPrecision from "./sections/SectorSpecificPrecision";
import Footer from "@/reusable_sections/Footer";
export default function IndustriesPage() {
  return <div>
      <MainNavigation />
      <ModernHealthcareSimplified />
      <SectorSpecificPrecision />
      <Footer />
    </div>;
}